var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"prijava",attrs:{"align":"middle","frameborder":"0","scrolling":"no","src":"https://survey.alchemer.eu/s3/90436937/IzziRokus-blog-prijava-na-novice"}})}
var staticRenderFns = []

export { render, staticRenderFns }